import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { NavigationProviderService } from '@prcins/utils';
import { BRAND, Brand, ADMIN } from '@prcins/constants';
var MobileHeaderComponent = /** @class */ (function () {
    function MobileHeaderComponent(navigationProvider) {
        this.navigationProvider = navigationProvider;
        this.logOut = new EventEmitter();
        this.softLogOut = new EventEmitter();
        this.brand = localStorage.getItem(BRAND);
        this.mainPage = Brand[this.brand].urlEnterpriseWeb;
        this.showNavigationPanel = false;
    }
    MobileHeaderComponent.prototype.ngOnInit = function () {
        this.navMenu = this.activeMenus;
        this.isAdmin = sessionStorage.getItem(ADMIN) === 'Y';
    };
    MobileHeaderComponent.prototype.menuNavigationHandler = function (methodName) {
        this.navigationProvider[methodName]();
    };
    MobileHeaderComponent.prototype.toggleNavMenu = function () {
        this.showNavigationPanel = !this.showNavigationPanel;
    };
    MobileHeaderComponent.prototype.showSubMenu = function (menuFlag) {
        var _a;
        var val = !this.navMenu[menuFlag];
        this.navMenu = tslib_1.__assign({}, this.activeMenus, (_a = {}, _a[menuFlag] = val, _a));
    };
    MobileHeaderComponent.prototype.onMenuClick = function (menu) {
        this.showNavigationPanel = false;
        this.navMenu = tslib_1.__assign({}, this.activeMenus);
    };
    MobileHeaderComponent.prototype.onLogout = function () {
        this.logOut.next();
    };
    MobileHeaderComponent.prototype.onSoftLogout = function () {
        this.softLogOut.next();
    };
    MobileHeaderComponent.prototype.showLink = function (subMenu) {
        if (!subMenu.route) {
            return false;
        }
        if (subMenu.disable) {
            if (subMenu.waitConditionally) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    return MobileHeaderComponent;
}());
export { MobileHeaderComponent };
